module.exports = __webpack_public_path__ + "img/rukavy_81_seda.d3fcd8fb.png";